/* eslint-disable no-sequences */
import axios from "axios";
import { apiToken, apiUrl_forCart } from "./constants";

const CancelToken = axios.CancelToken;

// get cart
export let cancelGetCartTempApi;
export async function getCartByTemp(token, temp_order_id) {
    if (token && temp_order_id) {
        const cart = await axios.get(
            apiUrl_forCart + "?temp_order_id=" + temp_order_id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetCartTempApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}

// get cart
export let cancelGetCartApi;
export async function getCart(token, store_id, cart_id) {
    if (token) {
        const cart = await axios.get(
            apiUrl_forCart + "?store_id=" + store_id + "&cart_id=" + cart_id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetCartApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}

// add cart
export let cancelAddCartApi;
export async function addCart(token, cartData) {
    if ((token, cartData)) {
        const cart = await axios.put(
            apiUrl_forCart,
            cartData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelAddCartApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}

// update customer
export let cancelEditCartApi;
export async function editCustomer(token, cartData) {
    if ((token, cartData)) {
        const cart = await axios.put(
            apiUrl_forCart + cartData.user_id,
            cartData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelEditCartApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}

// delete delete cart
export let cancelDeleteCartApi;
export async function deleteCart(token, cart_id, token_id) {
    if ((token, cart_id, token_id)) {
        const cart = await axios.delete(
            apiUrl_forCart + cart_id + "/" + token_id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelDeleteCartApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}

// empty cart
export let cancelEmptyCartApi;
export async function emptyCart(token, temp_order_id) {
    if ((token, temp_order_id)) {
        const cart = await axios.delete(
            apiUrl_forCart + "empty/" + temp_order_id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelDeleteCartApi = c;
                }),
            }
        );
        return cart;
    } else {
        console.log("Please add required parameters");
    }
}

// get cart item
export let cancelGetCartItemsWithOrderIdApi;
export async function getCartItemsWithOrderId(token, tempOrderId) {
    if (token && tempOrderId) {
        const cartData = await axios.get(
            apiUrl_forCart + "?temp_order_id=" + tempOrderId,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCartItemsWithOrderIdApi = c;
                }),
            }
        );
        return cartData;
    } else {
        console.log("Please add required parameters");
    }
}
